module.exports = __webpack_public_path__ + "static/media/icon@2x.a69483f2.png";